"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgSeries(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("rect", { x: 3, y: 15, width: 28, height: 18, rx: 1.895, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 20.625c0-.287.302-.474.56-.345l6.617 3.309a.386.386 0 010 .691l-6.618 3.31a.386.386 0 01-.559-.346v-6.619z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M9 11V8.895C9 7.848 9.848 7 10.895 7h24.21C36.152 7 37 7.848 37 8.895V22.19a1.895 1.895 0 01-1.895 1.895", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgSeries;
//# sourceMappingURL=Series.js.map